<div id="bilderKarussell">
  <div id="bilderkarusellGrp">
    <div class="BilderKarusselContent">
      <img src="assets/icons/pwa-anleitung/{{ plattform }}/Anleitung{{aktiv}}.webp"/>
      <span [innerHTML]="this.pwaInstallManual[plattform][aktiv - 1]"></span><br/>
    </div>
    <div id="buttonGrp">
      <button [class.active]="aktiv == 1" (click)="bildWechseln(1)">1</button>
      <button [class.active]="aktiv == 2" (click)="bildWechseln(2)">2</button>
      <button [class.active]="aktiv == 3" (click)="bildWechseln(3)">3</button>
    </div>
  </div>
</div>
